import React, { useState } from "react";
import { DocumentGlType, JournalPickerType } from "../../domain/entities/AccountTreeEntity";
import { GLMappingEntity } from "../../domain/entities/GLMappingEntity";
import { useAccountNameTree } from "../hooks/useAccountNameTree";
import { GlTreePickerShell } from "./GlTreePickerShell";

export interface AccountNameDropdownProps {
  docType: DocumentGlType;
  journalType?: JournalPickerType;
  selectedAccountId?: string;
  selectedAccountName?: string;
  onSelect: (account: GLMappingEntity) => void;
  disabled?: boolean;
  className?: string;
  dropdownClassName?: string;
}

export function AccountNameDropdown({
  docType,
  journalType,
  selectedAccountId,
  selectedAccountName,
  onSelect,
  disabled = false,
  className = "",
  dropdownClassName = "",
}: AccountNameDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);

  const treeState = useAccountNameTree({
    docType,
    journalType,
    selectedAccountId,
    enabled: isOpen && !disabled,
  });

  return (
    <GlTreePickerShell
      treeState={treeState}
      selectedAccountId={selectedAccountId}
      selectedAccountName={selectedAccountName}
      onSelect={onSelect}
      disabled={disabled}
      className={className}
      dropdownClassName={dropdownClassName}
      onOpenChange={setIsOpen}
    />
  );
}

export default AccountNameDropdown;
